export default __webpack_public_path__ + "static/media/unrevealed_rare.dada6b82.jpg";